<template>
    <div class="tabs">
      <div class="tabs-navigation">
        <button 
          v-for="(tab, index) in tabs" 
          :key="index" 
          :class="['tab-button', { active: activeTab === index } ]"
          @click="selectTab(index)"
        >
          {{ tab }}
        </button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "TabsComponent",
    props: {
      tabs: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        activeTab: 0, // Aktívna záložka (index)
      };
    },
    methods: {
      selectTab(index) {
        this.activeTab = index;
        this.$emit('tab-selected', index);
      },
    },
  };
  </script>
  
  <style scoped>
  .tabs {
    display: flex;
    flex-direction: column;
    
  }
  .tabs-navigation {
    display: flex;
    background: #FAFAFA;
    border-radius: 10px;
    
}
  .tab-button {
    font-family: 'Poppins', sans-serif;
    padding: 5px 15px;
    margin: 0;
    min-width: 200px;
    border: none;
    border-radius: 8px;
    margin: 4px;
    background-color: transparent;
    color: #9D9D9D;
    font-size: 14px;
    cursor: pointer;
    font-weight: 400;
    transition: 0.2s;
  }
  .tab-button.active {
    background-color: white;
    color: #2C3E50;
    box-shadow: rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px;
    font-weight: 500;
  }
  .tab-button:hover {
    color: #2C3E50;
  }
  </style>
  
